import { CompanyDao, atomWithLoadMore } from '@rock/db-admin';
import type { Company, CompanyId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const companyDao = new CompanyDao();

export const companiesState = atomWithLoadMore<Company>(({ limitAtom, sortAtom }) =>
    companyDao.companiesAtom(limitAtom, sortAtom),
);

export const companyDetailsState = atomFamily(
    (companyId: CompanyId | undefined) => companyDao.companyAtom(atom(companyId)),
    shallowEqual,
);
